// extracted by mini-css-extract-plugin
export default {"zoomModal":"q2-z","image":"r2-z","button":"s2-z","isOverlayShown":"t2-z"};